import React, { useState, useEffect, useContext } from 'react';
import { AnimationContext } from '../context/AnimationContext';
import './ChatbotPage.css';

const AnimatedQuestion = React.memo(({ text = "How are you feeling today?" }) => {
  const [words, setWords] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const { hasAnimatedQuestion, setHasAnimatedQuestion } = useContext(AnimationContext);

  useEffect(() => {
    const wordArray = text.split(' ');
    setWords(wordArray);
    
    const totalDelay = (wordArray.length - 1) * 200 + 500;
    const timer = setTimeout(() => {
      setIsComplete(true);
      setHasAnimatedQuestion(true);
    }, totalDelay);

    return () => clearTimeout(timer);
  }, [text, setHasAnimatedQuestion]);

  return (
    <h1 className={`animated-question ${isComplete ? 'complete' : ''}`}>
      {words.map((word, index) => (
        <span 
          key={`word-${index}`}
          className="animated-word"
          style={{
            display: 'inline-block',
            opacity: hasAnimatedQuestion ? 1 : 0,
            animation: !hasAnimatedQuestion ? `fadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards` : 'none',
            animationDelay: !hasAnimatedQuestion ? `${index * 400}ms` : '0ms',
            marginRight: '0.4rem'
          }}
        >
          {word}
        </span>
      ))}
    </h1>
  );
});

AnimatedQuestion.displayName = 'AnimatedQuestion';

export default AnimatedQuestion;